module.exports = __webpack_public_path__ + "img/cross_0.0016bbbc.png";